import onReady from 'utils/on-ready';
import ReadMoreTextBox from 'static/script/utils/read-more-text-box';
import './brand.scss';

export default () => {
    onReady(() => {
        ReadMoreTextBox.attachTo('[data-read-more-text-box]');
    });
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/brand/index.js